const searchStore = {
  namespaced: true,
  state: () => ({
    showModal: false,
    modalKbliFilter: false,

    vendorName: '',
    chooseSio: null,
    chooseMine: null,
    choosePraqualifikasiK3l: null,
    choosePraqualifikasiKplh: null,

    choosePeriodePO: null,
    choosePeriodeEvent: null,
    choosePeriodeKontrak: null,
    choosePeriodeKinerjaPo: null,

    chooseK3lScore: [],
    chooseKplhScore: [],
    poScoreStart: 0,
    poScoreEnd: 0,
    spmScoreStart: 0,
    spmScoreEnd: 0,
    chooseStatus: null,
    poStartDate: null,
    poEndDate: null,
    eventStartDate: null,
    eventEndDate: null,
    spmStartDate: null,
    spmEndDate: null,
    kinerjaPoStartDate: null,
    kinerjaPoEndDate: null,
    k3lStartDate: null,
    k3lEndDate: null,
    kplhStartDate: null,
    kplhEndDate: null,
    sioStartDate: null,
    sioEndDate: null,
    countries: [],
    choosedCountry: null,
    provinces: [],
    choosedProvince: null,
    cities: [],
    choosedCity: null,
    districs: [],
    choosedDistric: null,
    villages: [],
    choosedVillage: null,
    choosedKbli: [],
    kbliList: [],
    k3lCategories: null,
    kplhCategories: null
  }),
  mutations: {
    SHOW_MODAL(state, status) {
      state.showModal = status
    },
    SET_OTHER_MODAL(state, modal) {
      state[modal.name] = modal.status
    },
    SET_SEARCH_VALUE(state, search) {
      state[`${search.name}`] = search.value
    },
    RESET_FILTER(state) {
      state.vendorName= ''
      state.chooseSio= null
      state.chooseMine= null
      state.choosePraqualifikasiK3l= null
      state.choosePraqualifikasiKplh= null
      state.choosePeriodePO= null
      state.choosePeriodeEvent= null
      state.choosePeriodeKinerjaPo= null
      state.chooseK3lScore= []
      state.chooseKplhScore= []
      state.poScoreStart= 0
      state.poScoreEnd= 0
      state.spmScoreStart= 0
      state.spmScoreEnd= 0
      state.chooseStatus= null
      state.poStartDate= null
      state.poEndDate= null
      state.eventStartDate= null
      state.eventEndDate= null
      state.spmStartDate= null
      state.spmEndDate= null
      state.kinerjaPoStartDate= null
      state.kinerjaPoEndDate= null
      state.k3lStartDate= null
      state.k3lEndDate= null
      state.kplhStartDate= null
      state.kplhEndDate= null
      state.sioStartDate= null
      state.sioEndDate= null
      state.countries= []
      state.choosedCountry= null
      state.provinces= []
      state.choosedProvince= null
      state.cities= []
      state.choosedCity= null
      state.districs= []
      state.choosedDistric= null
      state.villages= []
      state.choosedVillage= null
      state.choosedKbli= []
      state.kbliList= []
      state.k3lCategories= null
      state.kplhCategories= null
    }
  },
  actions: {
  }
}

export default searchStore